import { selectedTimeAtom } from "@/api/atoms";
import { useAtomValue } from "jotai";

import { AreasList } from "./AreaList";

const topAreas = {
  2020: [
    { name: "Cambridge", rate: 1218 },
    { name: "Oxford", rate: 640 },
    { name: "Newcastle upon Tyne", rate: 454 },
    { name: "Bournemouth", rate: 394 },
    { name: "York", rate: 390 },
  ],
  2021: [
    { name: "City of London", rate: 3986 },
    { name: "Cambridge", rate: 1263 },
    { name: "Oxford", rate: 976 },
    { name: "Hammersmith and Fulham", rate: 732 },
    { name: "Tower Hamlets", rate: 702 },
  ],
  2022: [
    { name: "Cambridge", rate: 727 },
    { name: "Oxford", rate: 703 },
    { name: "York", rate: 512 },
    { name: "Newcastle upon Tyne", rate: 434 },
    { name: "Peterborough", rate: 395 },
  ],
  2023: [
    { name: "Cambridge", rate: 812 },
    { name: "Oxford", rate: 688 },
    { name: "York", rate: 556 },
    { name: "Newcastle upon Tyne", rate: 325 },
    { name: "Cardiff", rate: 312 },
  ],
  2024: [
    { name: "Cambridge", rate: 729 },
    { name: "Oxford", rate: 660 },
    { name: "York", rate: 445 },
    { name: "Newcastle upon Tyne", rate: 252 },
    { name: "Cardiff", rate: 233 },
  ],
  2025: [
    { name: "Oxford", rate: 454 },
    { name: "Cambridge", rate: 419 },
    { name: "York", rate: 285 },
    { name: "Cardiff", rate: 199 },
    { name: "Newcastle upon Tyne", rate: 190 },
  ],
};
const bottomAreas = {
  2020: [
    { name: "Wigan", rate: 1 },
    { name: "Bury", rate: 1 },
    { name: "Stockport", rate: 1 },
    { name: "Rochdale", rate: 3 },
    { name: "Manchester", rate: 7 },
  ],
  2021: [
    { name: "Rochdale", rate: 1 },
    { name: "Trafford", rate: 1 },
    { name: "Wigan", rate: 1 },
    { name: "Manchester", rate: 4 },
    { name: "Stockport", rate: 4 },
  ],
  2022: [
    { name: "Bolton", rate: 1 },
    { name: "Wigan", rate: 2 },
    { name: "Manchester", rate: 5 },
    { name: "Stockport", rate: 7 },
    { name: "Dudley", rate: 12 },
  ],
  2023: [
    { name: "Liverpool", rate: 1 },
    { name: "Bolton", rate: 1 },
    { name: "Plymouth", rate: 1 },
    { name: "Wigan", rate: 2 },
    { name: "Rochdale", rate: 2 },
  ],
  2024: [
    { name: "Liverpool", rate: 0.1 },
    { name: "Bolton", rate: 0.7 },
    { name: "Stockport", rate: 0.7 },
    { name: "Rochdale", rate: 1 },
    { name: "Salford", rate: 1.4 },
  ],
  2025: [
    { name: "Liverpool", rate: 0 },
    { name: "Bolton", rate: 0 },
    { name: "Wigan", rate: 0 },
    { name: "Rochdale", rate: 0 },
    { name: "Salford", rate: 1 },
  ],
};

export function AreasCard() {
  const selectedTime = useAtomValue(selectedTimeAtom);

  const year =
    selectedTime === 1
      ? 2020
      : selectedTime === 2
        ? 2021
        : selectedTime === 3
          ? 2022
          : selectedTime === 4
            ? 2023
            : selectedTime === 5
              ? 2024
              : 2025;

  return (
    <div className="pt-5 md:py-5">
      <div className="flex gap-3">
        <h2 className="leading-20 text-xs font-bold uppercase text-gray">Most affected areas</h2>
        <h3 className="mb-2 ml-auto mt-0 text-xs font-bold leading-5 text-gray">Rate/100k</h3>
      </div>
      <AreasList areas={topAreas[year]} />
      <hr />
      <div className="mt-5 flex gap-3">
        <h2 className="text-xs font-bold uppercase leading-5 text-gray">Least affected areas</h2>
        <h3 className="mb-2 ml-auto mt-0 text-xs font-bold leading-5 text-gray">Rate/100k</h3>
      </div>
      <AreasList areas={bottomAreas[year]} />
    </div>
  );
}
